import { Routes } from '@angular/router';
import { ArticleResolver, NewsResolver } from 'app/shared/article.resolver';
import { PrincipauxResolver } from 'app/shared/principaux.resolver';
import { recommendationsResolver } from 'app/shared/recommendations.resolver';
import { Error404Component } from '../error/error-404/error-404.component';
import { ArticleComponent } from './article/article.component';
import { ListeArticleComponent } from './liste-article/liste-article.component';
import { ListeNewsComponent } from './liste-news/liste-news.component';
import { NewsComponent } from './news/news.component';
import { YoutubePlayerComponent } from './youtube-player/youtube-player.component';
import { articleUrlMatcher, newsUrlMatcher } from 'app/shared/articlesUrlMatcher';

export default [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/',
    },
     // Malformed URL route (must come before normal routes)
     {
        matcher: articleUrlMatcher,
        component: ArticleComponent,
        resolve: {
          article: ArticleResolver,
          recommendations: recommendationsResolver,
          principaux: PrincipauxResolver
        }
      },  
      {
        matcher: newsUrlMatcher,
        component: NewsComponent,
        resolve: {
          news: NewsResolver,
          recommendations: recommendationsResolver,
          principaux: PrincipauxResolver
        }
      },  
    {
        path: 'articles/:nom/:id',
        component: ArticleComponent,
        resolve: {
            article: ArticleResolver,
            recommendations: recommendationsResolver,
            principaux: PrincipauxResolver,
        },
    },
    {
        path: 'news/:nom/:id',
        component: NewsComponent,
        resolve: {
            news: NewsResolver,
            recommendations: recommendationsResolver,
            principaux: PrincipauxResolver,
        },
    },
    {
        path: 'articles',
        component: ListeArticleComponent,
    },
    {
        path: 'news',
        component: ListeNewsComponent,
    },
    {
        path: 'video',
        component: YoutubePlayerComponent,
    },
/*  // Route directe pour la 404 (standalone)
 {
    path: '404', 
    component: Error404Component
  }, */

/*   // Catch-all route - DOIT ÊTRE LA DERNIÈRE
  {
    path: '**',
    redirectTo: '/404'
  } */
] as Routes;
